import React from 'react';
import { ArrowRightIcon, BitcoinIcon, CoinsIcon, LineChartIcon, RefreshCwIcon } from 'lucide-react';
import { MARKETS } from '../data/content';
import { Reveal } from './Reveal';
import { AFFILIATE_URL, trackRegisterClick } from '../utils/tracking';
const ICONS: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  forex: RefreshCwIcon,
  indices: LineChartIcon,
  metales: CoinsIcon,
  cripto: BitcoinIcon
};
const LINK_LABELS: Record<string, string> = {
  forex: 'Operar Forex',
  indices: 'Operar Índices',
  metales: 'Operar Metales',
  cripto: 'Operar Cripto'
};
export function Markets() {
  return <section id="mercados" className="bg-canvas py-20 sm:py-24" data-id="element-127" data-mp="2ucbcl7i2bmxr">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8" data-id="element-128" data-mp="2z9tnv4jjye8x">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-129" data-mp="2z9bmjti199u5">
          <p className="text-[11px] font-semibold uppercase tracking-overline text-brand-600" data-id="element-130" data-mp="34a7lrtrfw7t8">
            Oportunidades
          </p>
          <h2 className="mt-4 text-[2rem] font-semibold leading-[1.1] tracking-[-0.02em] text-ink-900 sm:text-[2.6rem]" data-id="element-131" data-mp="38b18wkx25il2">
            Explora diferentes mercados
          </h2>
          <p className="mt-5 text-[15.5px] leading-relaxed text-ink-500" data-id="element-132" data-mp="2u7vl30uybg72">
            Una experiencia diseñada para quienes buscan acceder a diferentes
            categorías de mercados desde una plataforma digital.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-133" data-mp="3hy9eovt6pn3r">
          {MARKETS.map((market, i) => {
          const Icon = ICONS[market.key];
          return <Reveal key={market.key} delay={i * 0.05} className="h-full" data-id="element-134" data-mp="3d197ghklmeb2" data-mpi={i}>
                <li className="group flex h-full flex-col rounded-2xl border border-line bg-white p-7 shadow-card transition-[transform,box-shadow,border-color] duration-200 ease-expo hover:-translate-y-1 hover:border-brand-200 hover:shadow-lift" data-id="element-135" data-mp="386v8k56q9p1n">
                  <span className="grid h-12 w-12 place-items-center rounded-xl bg-brand-100 text-brand-600 transition-colors duration-200 ease-expo group-hover:bg-brand-600 group-hover:text-white" data-id="element-136" data-mp="3vyagqel6r0kt">
                    <Icon className="h-5 w-5" data-id="element-137" data-mp="1yzbjiej5uvfh" />
                  </span>
                  <h3 className="mt-6 text-[19px] font-semibold tracking-[-0.01em] text-ink-900" data-id="element-138" data-mp="1z1nv89ybs9k3">
                    {market.title.charAt(0) + market.title.slice(1).toLowerCase()}
                  </h3>
                  <p className="mt-3 text-[14.5px] leading-relaxed text-ink-500" data-id="element-139" data-mp="1p7f7dzk8p4s9">
                    {market.description}
                  </p>
                  <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer sponsored" onClick={() => trackRegisterClick('market_card', market.title)} className="mt-auto inline-flex items-center gap-2 pt-7 text-[14px] font-semibold text-brand-600 transition-colors duration-200 ease-expo hover:text-brand-700" data-id="element-140" data-mp="1fbu9odm7eqob">
                    {LINK_LABELS[market.key]}
                    <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-expo group-hover:translate-x-1" aria-hidden="true" data-id="element-141" data-mp="p11z8j38hnzv" />
                  </a>
                </li>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}